/* eslint-disable import/no-cycle */
import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { RouteLocationNormalized } from 'vue-router';

export const useHistoryStore = defineStore('history', () => {
    const historyIndex = ref(-1);
    const history = ref<string[]>([]);

    const pop = () => {
        history.value.pop();
    };

    const push = (route: RouteLocationNormalized) => {
        history.value.push(route.path);
    };

    const moveIndex = (range: number) => {
        const newIndex = historyIndex.value + range;
        const min = 0;
        const max = history.value.length - 1;

        if (newIndex > max) {
            historyIndex.value = max;
        } else if (newIndex < min) {
            historyIndex.value = min;
        } else {
            historyIndex.value = newIndex;
        }
    };

    const record = (route: RouteLocationNormalized) => {
        // Reloading same page
        if (history.value.length && history.value[history.value.length - 1] === route.path) {
            pop();
            push(route);
            return false;
        }
        // Going back
        if (history.value.length > 1 && history.value[history.value.length - 2] === route.path) {
            pop();
            moveIndex(-1);

            return false;
        }

        push(route);
        moveIndex(1);
        return true;
    };

    return {
        historyIndex,
        history,

        pop,
        push,
        moveIndex,

        record,
    };
});
